import React, { useEffect, useRef, useState } from "react";
import { Box, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
// import "./slider.css";
import { useNavigate } from "react-router-dom";
import OnboardingModal from "./Modal/OnboardingModal";

const slides = [
  {
    image: "/SAPImages/Dashboard/SAP_Banner1.png",
    button: "Start Building Your Profile",
    // directionLink: "/test-prep/demos",
  },
  {
    image: "/SAPImages/Dashboard/SAP_Banner2.png",
    button: "Enroll Now",
    // directionLink: "/test-prep/classes",
  },
  {
    image: "/SAPImages/Dashboard/SAP_Banner3.png",
    button: "Explore Test Preparation",
    // directionLink: "/sap/dashboard",
  },
];

export default function WelcomeCard() {
  const navigate = useNavigate();
  const swiperRef = useRef(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const handleResize = () => swiperRef.current?.swiper?.update();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: {
          xs: 375,
          sm: 500,
          md: 700,
          lg: 900,
          xl: 1200,
        },
        minHeight: { xs: "100px", md: "270px" },

        pb: 3,
        position: "relative",
      }}
    >
      <Box width="100%">
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{
            clickable: true,
            el: ".custom-pagination",
          }}
          autoplay={{ delay: 4000 }}
          spaceBetween={20}
          slidesPerView={1}
          loop
          observer={true}
          observeParents={true}
          resizeObserver={true}
        >
          {slides.map((slide, i) => (
            <SwiperSlide key={i}>
              <Box
                sx={{
                  position: "relative",
                  borderRadius: 3,
                  overflow: "hidden",
                }}
              >
                {/* Banner Image */}
                <Box
                  component="img"
                  src={slide.image}
                  alt={`banner-${i}`}
                  sx={{
                    position: "relative",
                    borderRadius: 5,
                    overflow: "hidden",
                    width: "100%",
                    height: "100%",
                    // aspectRatio: "16 / 6", // controls image shape
                  }}
                />

                {/* Floating Button */}
                <Button
                  variant="contained"
                  endIcon={<img src="/newdashboard/Banner/arrow.png" />}
                  sx={{
                    position: "absolute",
                    bottom: { xs: 8, sm: 12, md: 50, xl: 80 },
                    left: { xs: 8, sm: 16, md: 44, xl: 70 },
                    bgcolor: "#000",
                    color: "#fff",
                    borderRadius: 16,
                    textTransform: "none",
                    fontWeight: 700,
                    fontFamily: "Inter",
                    px: { xs: 1.8, sm: 2.5, md: 3 },
                    py: { xs: 0.4, sm: 0.6, md: 0.8 },
                    fontSize: { xs: 12, sm: 12, md: 12, xl: 14 },
                    "&:hover": { bgcolor: "#222" },
                  }}
                  // onClick={() => navigate(slide.directionLink)}
                  onClick={() => setOpen(true)}
                >
                  {slide.button}
                </Button>
                <OnboardingModal open={open} onClose={() => setOpen(false)} />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>

      {/* Custom pagination below the images */}
      <Box sx={{ width: "100%" }}>
        <Box
          className="custom-pagination"
          sx={{
            position: "absolute",
            bottom: 0,
            left: "50% !important",
            transform: "translateX(-50%)",
          }}
        />
      </Box>
    </Box>
  );
}
